module.exports = __webpack_public_path__ + "img/18.2e6ad1c5.jpg";